import { Flex } from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { SPACING } from "@/generic/config";
import { productIcon } from "./product-icons";

/**
 * A product's name with its chosen icon in front, used wherever products are
 * listed (order rows, product lists, summaries). No icon chosen = just the name.
 */
const ProductName = ({ code, icon }: { code: string | null | undefined, icon?: string | null }) => {
    const definition = productIcon(icon);
    return (
        <Flex as="span" display="inline-flex" alignItems="center" gap={SPACING}>
            {definition && <FontAwesomeIcon icon={definition} fixedWidth />}
            <span>{code}</span>
        </Flex>
    );
};

export default ProductName;
